module.exports = __webpack_public_path__ + "static/media/back_to_list_icon.3a2efe33.svg";